import React, { useEffect, useState, useCallback } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  Tooltip,
  IconButton,
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import { getMailList } from '../services/mailService';

export default function SentMailsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await getMailList();
      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
      setRows(data);
    } catch (err) {
      setError('Veriler yüklenirken hata oluştu: ' + (err.message || 'Bilinmeyen hata'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleExport = () => {
    if (!rows.length) return;
    const exportData = rows.map((row) => ({
      ID: row.id,
      'Mail': row.mail,
      'Firma Adı / Yetkili Kişi': row.title || '',
      'Dönem': row.donem || '',
      'Cari Bakiye': row.cariBakiye || '',
      'Son Ödeme Tarihi': row.sonOdemeTarihi || '',
      'Mail Gönderim Tarihi': formatDate(row.insertDate),
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Gönderilen Mailler');
    XLSX.writeFile(wb, 'gonderilen_mailler.xlsx');
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString('tr-TR');
    } catch {
      return dateStr;
    }
  };

  return (
    <Box>
      {/* Başlık */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight={600} sx={{ flexGrow: 1 }}>
          Gönderilen Mailler
        </Typography>
        <Tooltip title="Yenile">
          <IconButton onClick={fetchData} sx={{ mr: 1 }} disabled={loading}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
        <Button
          variant="outlined"
          startIcon={<FileDownloadIcon />}
          onClick={handleExport}
          disabled={loading || !rows.length}
          sx={{ color: '#1565c0', borderColor: '#1565c0' }}
        >
          EXPORT
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: '#fafafa' }}>
                <TableCell sx={{ fontWeight: 700, color: '#555', fontSize: '0.75rem' }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#555', fontSize: '0.75rem' }}>MAIL</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#555', fontSize: '0.75rem' }}>
                  FİRMA ADI / YETKİLİ KİŞİ
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#555', fontSize: '0.75rem' }}>DÖNEM</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#555', fontSize: '0.75rem' }}>CARİ BAKİYE</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#555', fontSize: '0.75rem' }}>
                  SON ÖDEME TARİHİ
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#555', fontSize: '0.75rem' }}>
                  MAİL GÖNDERİM TARİHİ
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 6, color: '#999' }}>
                    Kayıt bulunamadı.
                  </TableCell>
                </TableRow>
              ) : (
                rows.map((row, idx) => (
                  <TableRow
                    key={row.id || idx}
                    hover
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.mail}</TableCell>
                    <TableCell>{row.title || '-'}</TableCell>
                    <TableCell>{row.donem || '-'}</TableCell>
                    <TableCell>{row.cariBakiye || '-'}</TableCell>
                    <TableCell>{row.sonOdemeTarihi || '-'}</TableCell>
                    <TableCell>{formatDate(row.insertDate)}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      {!loading && rows.length > 0 && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          Toplam {rows.length} kayıt
        </Typography>
      )}
    </Box>
  );
}
